module.exports = __webpack_public_path__ + "static/media/download_template_icon.ed7d6fac.svg";